import axios from "axios";
import { Image, message } from "antd";
import { useContext, useState } from "react";

import styles from "./profile.module.css";
import BackIcon from "../../Components/BackIcon";
import { UserStates } from "../../context/UserContext";
import { getUserDetailsUrl } from "../../apis/constants";
import dummyUserImg from "../../assets/user-dummy.png";
import { isValidUrl } from "../../constants/constants";

export default function Profile() {

  const { accessToken, user, setUser } = useContext(UserStates);

  const userId = localStorage.getItem("userId");

  const [profilePic, setProfilePic] = useState(
    localStorage.getItem("profile-pic")
  );

  // const [user, setUser] = useState(null);

  // get user details
  // const getUserDetails = () => {
  //   const config = {
  //     method: "get",
  //     url: `${getUserDetailsUrl}${userId}`,
  //     headers: { Authorization: accessToken },
  //   };

  //   axios(config)
  //     .then((res) => {
  //       setUser(res.data.data);
  //       localStorage.setItem("profile-pic", res.data.data.image);
  //     })
  //     .catch((err) => err);
  // };

  // update user details
  // const updateUserDetails = () => {
  //   const config = {
  //     method: "patch",
  //     url: `${getUserDetailsUrl}${userId}`,
  //     data: user,
  //     headers: { Authorization: accessToken },
  //   };

  //   axios(config)
  //     .then((res) => {
  //       setUser(res.data.data);
  //       message.success("Profile is successfully updated");
  //     })
  //     .catch((err) => err);
  // };
  const updateUserDetails = (image) => {
    const { number, ...filteredUser } = user;

    console.log("filteredUser", filteredUser);

    let form = new FormData();
    form.append("file", image);
    form.append("address[place]", user?.address?.place);
    // Map over filteredUser and append each key-value pair to FormData
    Object.entries(filteredUser).forEach(([key, value]) => {
      if (key !== "address") {
        form.append(key, value);
      }
    });

    const config = {
      method: "patch",
      url: `${getUserDetailsUrl}${userId}`,
      data: image !== undefined ? form : filteredUser,
      headers: { Authorization: accessToken },
    };

    axios(config)
      .then((res) => {
        message.success("Profile successfully updated");
        setUser(res.data.data);
        setProfilePic(res.data.data.image);
        localStorage.setItem("user-name", res.data.data.name);
        localStorage.setItem("profile-pic", res.data.data.image);
      })
      .catch((err) => err);
  };

  // useEffect(() => {
  //   getUserDetails();
  // }, []);

  return (
    <div style={{ padding: "20px" }}>
      <BackIcon page={"Edit Profile"} />
      {user !== null && (
        <div className={styles.container}>
          <Image
            src={isValidUrl(profilePic) ? profilePic : dummyUserImg}
            style={{
              width: "150px",
              height: "150px",
              borderRadius: "75px",
              objectFit: "cover",
            }}
          />
          <div className={styles.itemContainer}>
            <span>Shop Owner Name</span>
            <input
              type="text"
              name="name"
              value={user?.name}
              onChange={(e) => setUser({ ...user, name: e.target.value })}
            />
          </div>
          <div className={styles.itemContainer}>
            <span>Place</span>
            <input
              type="text"
              name="address"
              value={user?.address?.place}
              onChange={(e) =>
                setUser({
                  ...user,
                  address: {
                    ...user.address,
                    place: e.target.value,
                  },
                })
              }
            />
          </div>
          <div className={styles.itemContainer}>
            <span>Business Name</span>
            <input
              type="text"
              name="business_name"
              value={user?.businessName || user?.business_name}
              onChange={(e) =>
                setUser({ ...user, business_name: e.target.value })
              }
            />
          </div>
          {/* <div className={styles.itemContainer}>
            <button>Select from map</button>
          </div> */}
          <div className={styles.itemContainer}>
            <span>Address</span>
            {/* <input
              type="text"
              name="address"
              value={user?.address?.landmark}
              onChange={(e) => setUser({...user,})}
            /> */}
            <textarea
              style={{ width: "100%", height: "100px" }}
              type="text"
              name="address"
              value={user?.address?.landmark}
              //   onChange={(e) => setUser({ ...user })}
            />
          </div>
          <div className={styles.itemContainer}>
            <span>GST No</span>
            <input
              type="text"
              name="gst"
              value={user?.gst}
              onChange={(e) => setUser({ ...user, gst: e.target.value })}
            />
          </div>
          <div className={styles.itemContainer}>
            <span>Phone Number</span>
            <input
              type="text"
              name="number"
              value={user?.number}
              onChange={(e) => setUser({ ...user, number: e.target.value })}
            />
          </div>
          <div className={styles.itemContainer}>
            <span>Alternative Nubmer</span>
            <input
              type="text"
              name="alternative_number"
              value={user?.alternativeNumber || user?.alternative_number}
              onChange={(e) =>
                setUser({ ...user, alternative_number: e.target.value })
              }
            />
          </div>
          <div className={styles.itemContainer}>
            <span>State</span>
            <input
              type="text"
              name="address"
              value={user?.address?.state}
              onChange={(e) =>
                setUser({
                  ...user,
                  address: {
                    ...user.address,
                    state: e.target.value,
                  },
                })
              }
            />
          </div>
          <div className={styles.itemContainer}>
            <span>District</span>
            <input
              type="text"
              name="address"
              value={user?.address?.district}
              onChange={(e) =>
                setUser({
                  ...user,
                  address: {
                    ...user.address,
                    district: e.target.value,
                  },
                })
              }
            />
          </div>
          <div className={styles.itemContainer}>
            <span>Pin code</span>
            <input
              type="text"
              name="address"
              value={user?.address?.pincode}
              onChange={(e) =>
                setUser({
                  ...user,
                  address: {
                    ...user.address,
                    pincode: e.target.value,
                  },
                })
              }
            />
          </div>
          <div className={styles.itemContainer}>
            <span>Are you a?</span>
            <select
              value={user.type}
              onChange={(e) => setUser({ ...user, type: e.target.value })}
            >
              <option value={5} key={5}>
                Retailer
              </option>
              <option value={6} key={6}>
                Distributor
              </option>
              <option value={4} key={4}>
                Channel Partner Gold
              </option>
              <option value={7} key={7}>
                Channel Partner Diamond
              </option>
            </select>
          </div>
          <div className={styles.itemContainer}>
            <button onClick={updateUserDetails}>Save</button>
          </div>
        </div>
      )}
    </div>
  );
}
